// Impact-score presentation helpers (government-grade priority triage).

export const IMPACT_TIER = {
  severe: {
    label: "SEVERE",
    text: "text-atlas-red",
    border: "border-atlas-red/50",
    bg: "bg-atlas-red/10",
    dot: "#FF2A2A",
  },
  elevated: {
    label: "ELEVATED",
    text: "text-atlas-orange",
    border: "border-atlas-orange/50",
    bg: "bg-atlas-orange/10",
    dot: "#FF9500",
  },
  advisory: {
    label: "ADVISORY",
    text: "text-amber-300",
    border: "border-amber-300/40",
    bg: "bg-amber-300/5",
    dot: "#FCD34D",
  },
};

export const tierOf = (impact) => IMPACT_TIER[impact?.tier] || IMPACT_TIER.advisory;
